import React from 'react';

interface AstuteAccordionDescriptionHtmlProp {
    descriptions: (Element | null)[];
    indexNumber: number;
    nests: NodeListOf<Element> | undefined;
    descriptionsInnerHtml: number;
    transformHtml?: (html: string) => string;
}

export const AstuteAccordionDescription = (
    props: AstuteAccordionDescriptionHtmlProp
) => {
    const html =
        props.descriptions[props.indexNumber]?.innerHTML?.split(
            props.nests?.[0]?.outerHTML || ''
        )[props.descriptionsInnerHtml] || '';
    return (
        <>
            {props.nests && props.nests.length > 0 && (
                <div
                    dangerouslySetInnerHTML={{
                        __html: props.transformHtml
                            ? props.transformHtml(html)
                            : html,
                    }}
                />
            )}
        </>
    );
};
